import moment from "moment";
import Vue from "vue";
import { Mixin } from "vue-mixin-decorator";

@Mixin
class GeneralMixin extends Vue {
  public date_format(val: string) {
    return val ? moment(val).format("YYYY-MM-DD") : "";
  }
  public date_format_j(val: string) {
    return val ? moment(val).format("YYYY年MM月DD日") : "";
  }
  public date_format_md(val: string) {
    return val ? moment(val).format("MM-DD") : "";
  }
  public price_format(val: number) {
    return val ? val.toLocaleString() : 0;
  }
  public price_format_s(val: number) {
    return this.price_format(val) + "円";
  }
  public price_format_p(val: number) {
    return "¥" + this.price_format(val);
  }
}

export default GeneralMixin;
